'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genLoginSaga = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _jwtDecode = require('jwt-decode');

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

var _isPromise = require('is-promise');

var _isPromise2 = _interopRequireDefault(_isPromise);

var _effects = require('redux-saga/effects');

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

var _types = require('./types');

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var genLoginSaga = exports.genLoginSaga = function genLoginSaga(apiLogin, getToken, getDecoded) {
  var login = /*#__PURE__*/_regenerator2.default.mark(function login(action) {
    var payload, result, token, decoded;
    return _regenerator2.default.wrap(function login$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = action.payload;
            _context.prev = 1;
            _context.next = 4;
            return (0, _effects.call)(apiLogin, payload.username, payload.password);

          case 4:
            result = _context.sent;
            token = getToken(result);
            decoded = getDecoded(_jwtDecode2.default, result, payload);
            _context.next = 9;
            return (0, _effects.put)(actions.completeLogin(token, decoded, payload));

          case 9:
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](1);
            _context.next = 15;
            return (0, _effects.put)(actions.failLogin((0, _extends3.default)({}, _context.t0, {
              retryAction: action
            })));

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, login, this, [[1, 11]]);
  });

  var watchLogin = /*#__PURE__*/_regenerator2.default.mark(function watchLogin() {
    return _regenerator2.default.wrap(function watchLogin$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeEvery)(types.LOGIN_STARTED, login);

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, watchLogin, this);
  });

  return watchLogin;
};


// WEBPACK FOOTER //
// ./node_modules/nozzmo-redux-jwt/lib/sagas.js